export default "__VITE_ASSET__c00eb65c__"